import { render } from "./attachment.vue?vue&type=template&id=6925673c&scoped=true"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"

import "./attachment.vue?vue&type=style&index=0&id=6925673c&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6925673c"]])

export default __exports__